import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import SnackBar from "../SnackBar";
import { api_post } from "../../utils/Api";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.main,
        "& h6": {
            color: "red",
        },
    },
}));

const DuplicateConfigLevel = (props) => {
    const {
        className,
        open,
        itemId,
        itemName,
        setOpen,
        initializeData,
        rowsPerPage,
        ...rest
    } = props;

    const classes = useStyles();
    const [message, setAlertMessage] = useState('');
    const [severity, setAlertSeverity] = useState('success');
    const [openSnack, setOpenSnack] = useState(false);

    const handleCloseSnack = () => setOpenSnack(false);
    const handleCloseDialog = () => setOpen(false);

    const showAlertMessage = (msg) => {
        setAlertSeverity('error');
        setAlertMessage(msg);
        setOpenSnack(true);
    };

    const showErrorMessage = (errors) => {
        const firstKey = Object.keys(errors)[0];
        if (firstKey) {
            setAlertSeverity('error');
            setAlertMessage(errors[firstKey][0]);
            setOpenSnack(true);
        }
    };

    const handleDuplicate = () => {
        api_post(`student-level-configs/duplicate`, { studentLevelConfigId: itemId }).then((result) => {
            if (result.errors) {
                showErrorMessage(result.errors);
            } else if (result?.code !== 200 && result?.code !== 201) {
                showAlertMessage(result?.message || 'Technical error! Contact the Developers Team');
            } else {
                setAlertSeverity('success');
                setAlertMessage(result?.message || 'Element duplicated successfully');
                setOpenSnack(true);
                initializeData(rowsPerPage);
                setTimeout(() => {
                    handleCloseDialog();
                }, 1500);
            }
        });
    };

    return (
        <div {...rest} className={clsx(classes.root, className)}>
            <Dialog open={open} onClose={handleCloseDialog} fullWidth>
                <DialogTitle id="responsive-dialog-title">
                    <strong>Confirm Duplication</strong>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to duplicate <strong>{itemName || 'this level configuration'}</strong>?<br />
                        This action will create a copy with the same settings.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDuplicate} color="primary" variant="contained">
                        Confirm & Duplicate
                    </Button>
                </DialogActions>
            </Dialog>

            <SnackBar
                open={openSnack}
                handleClose={handleCloseSnack}
                message={message}
                severity={severity}
            />
        </div>
    );
};

DuplicateConfigLevel.propTypes = {
    className: PropTypes.string,
    open: PropTypes.bool,
    itemId: PropTypes.number,
    itemName: PropTypes.string,
    setOpen: PropTypes.func.isRequired,
};

export default DuplicateConfigLevel;
